import React from 'react';
export function QuotesPageV4() {
  return <div className="flex h-full min-h-screen flex-col overflow-hidden bg-[#F3F6F8]" data-id="element-12757" data-mp="ai4g5gm3xpzc">
      <header className="h-[72px] flex-shrink-0 border-b border-white/10 bg-[#142B4A]" aria-label="Quote V4 top bar" data-id="element-12758" data-mp="3bceu0654azkv" />
      <main className="flex-1 bg-[#F3F6F8]" aria-label="Quote V4 workspace" data-id="element-12759" data-mp="3pc6caj2o324o" />
    </div>;
}